/**
 * Pending admissions (1.3): what has been accepted and reserved and has not
 * started. Its own route and its own item in the OPERATE menu — the person
 * working this list may not be the person who decides referrals.
 *
 * A row arrives on Accept and leaves when the welcome call turns its hold into a
 * real start of care, or when it is released.
 */
import { Box, Typography } from "@mui/material";
import { useDemoSelector } from "../../store/useDemoStore";
import { PendingList } from "./PendingList";

export function PendingAdmissionsPage() {
  const branch = useDemoSelector((s) => s.config.branch.name);
  return (
    <Box sx={{ py: 2 }}>
      <Box sx={{ display: "flex", alignItems: "baseline", gap: 1, mb: 2 }}>
        <Typography variant="h5">Pending admissions</Typography>
        <Typography variant="body2" color="text.secondary">
          {branch}
        </Typography>
      </Box>
      <PendingList />
    </Box>
  );
}
